export default __webpack_public_path__ + "assets/no_album_art_t.png";